import { create } from 'zustand';

export interface DashboardState {
  /** True while a working SSE connection to /dashboard/stream is open. */
  sseConnected: boolean;
  /** True while the dashboard layout is mounted (drives heartbeat gating). */
  dashboardOpen: boolean;
  setSseConnected: (v: boolean) => void;
  setDashboardOpen: (v: boolean) => void;
  reset: () => void;
}

const initial = { sseConnected: false, dashboardOpen: false };

export const useDashboardStore = create<DashboardState>((set) => ({
  ...initial,
  setSseConnected: (v) => set({ sseConnected: v }),
  setDashboardOpen: (v) => set({ dashboardOpen: v }),
  reset: () => set(initial),
}));
